$(document).ready(function(){var windowsize=$(window).width();if(windowsize>767){var current_scroll=$(window).scrollTop();if(current_scroll>=300){$("#shopify-section-header").addClass("scrolled")}else{$("#shopify-section-header").removeClass("scrolled")}
$(window).scroll(function(){var scroll=$(window).scrollTop();if(scroll>=300){$("#shopify-section-header").addClass("scrolled")}else{$("#shopify-section-header").removeClass("scrolled")}})}})

/* ZGX flash-sale promo watcher. Persistent: re-initializes the promo card whenever the theme re-renders it. Safe no-op without #zgx-promo. Remove after promo ends. */
(function () {
  var END = new Date('2026-07-20T23:59:00+08:00').getTime();
  var iv = null;
  function pad(n) { return n < 10 ? '0' + n : '' + n }
  function initBox(box) {
    box.setAttribute('data-zgx-init', '1');
    try {
      var a = document.querySelector('ul.product-meta[data-price]') || document.getElementById('productPrice-product-template');
      if (a) {
        var t = a.closest('ul') || a;
        if (t.nextElementSibling !== box) t.insertAdjacentElement('afterend', box);
        box.style.margin = '14px 0';
        box.style.maxWidth = '560px';
      }
    } catch (e) {}
    var se = box.querySelector('#zgx-ends'), tm = box.querySelector('#zgx-timer');
    if (se) se.style.display = 'none';
    if (tm) tm.style.display = 'flex';
    try {
      if (/(^|; )discount_code=BYEBYECLOUD/.test(document.cookie) || localStorage.getItem('zgxApplied') === '1') {
        var ab = box.querySelector('#zgx-apply'), ap = box.querySelector('#zgx-applied');
        if (ab) ab.style.display = 'none';
        if (ap) ap.style.display = 'inline';
      }
    } catch (e) {}
    var abtn = box.querySelector('#zgx-apply');
    if (abtn) abtn.addEventListener('click', function () { try { localStorage.setItem('zgxApplied', '1') } catch (e) {} });
    var c = box.querySelector('#zgx-code'), cp = box.querySelector('#zgx-copied');
    if (c) c.addEventListener('click', function () {
      navigator.clipboard.writeText('BYEBYECLOUD').then(function () {
        if (cp) { cp.style.display = 'inline'; setTimeout(function () { cp.style.display = 'none' }, 1500) }
      })
    });
    if (iv) clearInterval(iv);
    var on = true;
    function tick() {
      var l = END - Date.now();
      var b = document.getElementById('zgx-promo');
      if (!b) return;
      if (l <= 0) { b.style.display = 'none'; clearInterval(iv); return }
      function set(sel, v) { var e = b.querySelector(sel); if (e) e.textContent = v }
      set('#zgx-d', pad(Math.floor(l / 86400000)));
      set('#zgx-h', pad(Math.floor(l / 3600000) % 24));
      set('#zgx-m', pad(Math.floor(l / 60000) % 60));
      set('#zgx-s', pad(Math.floor(l / 1000) % 60));
      var d = b.querySelector('#zgx-dot');
      if (d) { on = !on; d.style.opacity = on ? '1' : '0.35' }
    }
    iv = setInterval(tick, 1000);
    tick();
  }
  function scan() {
    var box = document.getElementById('zgx-promo');
    if (box && !box.getAttribute('data-zgx-init')) initBox(box);
  }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  setInterval(scan, 800);
  try { new MutationObserver(scan).observe(document.body || document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
